











import { Component, Vue } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import Growlib from './growlib'
import Yinhai from './yinhai'
import { hostname } from 'os'

@Component({
  components: {
    Growlib,
    Yinhai
  }
})
export default class Login extends ViewBase {
  host = ''
  getDomain() {
   this.host = this.$store.state.hostName
  }
  mounted() {
    this.getDomain()
  }
}
